import {
  usePreloadNavigationToPDP,
  ProductDetails,
} from "@faire/retailer-visitor-shared/views/product/preload/preloadNavigationToPDP";
import React from "react";

const PDP_HOVER_THRESHOLD_MS = 750;

export const usePrefetchOnHover = (
  productData: ProductDetails,
  productPageUrl: string
) => {
  const { productToken, bestImage, images, brandToken, showVerticalImagery } =
    productData;

  const preloadNavigationToPDP = usePreloadNavigationToPDP();

  const timeoutRef = React.useRef<ReturnType<typeof setTimeout> | undefined>(
    undefined
  );

  const onMouseEnter = React.useCallback(() => {
    if (!productToken) {
      return;
    }

    timeoutRef.current = setTimeout(() => {
      preloadNavigationToPDP(
        {
          productToken,
          bestImage,
          images,
          brandToken,
          showVerticalImagery,
        },
        productPageUrl
      );
    }, PDP_HOVER_THRESHOLD_MS);
  }, [
    preloadNavigationToPDP,
    showVerticalImagery,
    productToken,
    bestImage,
    images,
    brandToken,
    productPageUrl,
  ]);

  const onMouseLeave = React.useCallback(() => {
    if (!productToken) {
      return;
    }
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
  }, [productToken]);

  return {
    onMouseEnter,
    onMouseLeave,
  };
};
